import {
  getGiftIdsToPreload,
  getIsGiftPreloadEnabled,
} from "src/features/gifts/giftsSoc";
import { getGiftsVideoMp4Enabled } from "src/features/gifts/imports/abTest";
import { giftsCacheSelectors } from "src/features/gifts/imports/selectors";
import { preloadAssets } from "src/features/gifts/imports/serviceWorker";
import { Gift, RootState } from "src/features/gifts/imports/types";

export const sendPreloadAssets = (state: RootState) => {
  const isGiftPreloadEnabled = getIsGiftPreloadEnabled(state);
  const isGiftsVideoMp4Enabled = getGiftsVideoMp4Enabled(state);
  const giftIdsToPreload = getGiftIdsToPreload(state);

  if (
    !isGiftPreloadEnabled ||
    !isGiftsVideoMp4Enabled ||
    giftIdsToPreload.length === 0
  ) {
    return;
  }

  const urls = giftsCacheSelectors
    .getGiftsByIds(state, giftIdsToPreload)
    .filter(({ mp4AnimationUrl }: Gift) => mp4AnimationUrl)
    .map(({ mp4AnimationUrl }: Gift) => mp4AnimationUrl);

  preloadAssets(urls);
};
